/**
 * 使用方式
 * <div v-click-outside={onClickOutside}></div>
 */
export var clickOutside = {
  bind: function bind(el, _ref) {
    var value = _ref.value;

    el.handler = function (e) {
      if (el && !el.contains(e.target)) {
        value === null || value === void 0 ? void 0 : value(e);
      }
    };

    document.addEventListener('click', el.handler, true);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.handler, true);
    el.handler = null;
  }
};